import styled from 'styled-components';

// eslint-disable-next-line eag/no-css-property
export const WhatsappTextLink = styled.div<{isClickable: boolean}>`
  color: ${({theme}) => theme.colors.text.white};
  font-size: ${({theme}) => theme.fontSizes.text.small};
  font-style: italic;
  text-decoration: underline;
`;
